import { Component } from '@angular/core';

@Component({
  selector: 'app-success-changed',
  templateUrl: './success-changed.component.html',
  styleUrls: ['./success-changed.component.scss']
})
export class SuccessChangedComponent {}
